import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@material-ui/core";
import Footer from "../../Flight/components/Home Footer/Footer";
import classes from "../../../components/Flight/components/Services/Services.module.css";
import "./aboutUs.css";

const AboutUs = () => {
  return (
    <>
      <Grid
        container
        style={{ display: "flex", alignItems: "start" }}
        justifyContent="space-between"
      >
        <div
          className={classes["service-container"]}
          style={{
            backgroundImage: "url(/img/aboutUsCover.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            minHeight: "750px",
            padding: 0,
          }}
        ></div>
        <div
          className={classes["service-container"]}
          style={{
            background: "var(--themegreen)",
          }}
        >
          <div className={classes["services"]}>
            {/* <img src="/img/aboutUsCover.png" alt="About Us" />? */}
            <Typography
              variant="h5"
              style={{
                color: "#fff",
                textTransform: "capitalize",
                fontSize: "1.875rem",
                fontWeight: "700",
                paddingLeft: "8px",
              }}
            >
              About Us
            </Typography>
          </div>
        </div>
        <div
          style={{
            maxWidth: "70%",
            margin: "0 auto",
            textAlign: "start",
            marginTop: "3rem",
          }}
        >
          <Card className="about-child-card">
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              className="col-sm-12 col-md-4 col-lg-5"
            >
              <CardContent className="about-card-body">
                <Typography
                  component="div"
                  variant="h5"
                  style={{ fontSize: "2rem", marginBottom: "1rem" }}
                >
                  We make travel accessible for everyone
                </Typography>
                <Typography
                  variant="p"
                  color="text.secondary"
                  component="p"
                  style={{ marginBottom: "0.75rem" }}
                >
                  We believe everyone should be free to experience the world.
                  For us, there’s no greater freedom than choosing where you
                  want to be and how you want to get there.
                </Typography>
                <Typography variant="p" color="text.secondary" component="p">
                  That’s why we’re breaking down the barriers to low-cost
                  travel, making the world open and accessible for all.
                </Typography>
              </CardContent>
            </Box>
            <CardMedia
              component="img"
              className="col-sm-12 col-md-5 col-lg-4 about-card-media"
              image="/img/_1.png"
              alt="Live from space album cover"
            />
          </Card>
          <Card className="about-child-card">
            <CardMedia
              component="img"
              className="col-sm-12 col-md-5 col-lg-4 about-card-media"
              image="/img/_2.png"
              alt="Live from space album cover"
            />
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              className="col-sm-12 col-md-4 col-lg-5"
            >
              <CardContent className="about-card-body">
                <Typography
                  component="div"
                  variant="h5"
                  style={{ fontSize: "2rem", marginBottom: "1rem" }}
                >
                  Travel-Pick finds affordable travel options
                </Typography>
                <Typography
                  variant="p"
                  color="text.secondary"
                  component="p"
                  style={{ marginBottom: "0.75rem" }}
                >
                  Thanks to our unique Kiwi-Code, we’re able to find cheap
                  travel options other search tools can’t, so our customers will
                  never have that nagging doubt they’ve missed out on a better
                  deal elsewhere.
                </Typography>
              </CardContent>
            </Box>
          </Card>
          <Card className="about-child-card">
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
              className="col-sm-12 col-md-4 col-lg-5"
            >
              <CardContent className="about-card-body">
                <Typography
                  component="div"
                  variant="h5"
                  style={{ fontSize: "2rem", marginBottom: "1rem" }}
                >
                  We hack the system, you fly for less
                </Typography>
                <Typography
                  variant="p"
                  color="text.secondary"
                  component="p"
                  style={{ marginBottom: "0.75rem" }}
                >
                  We pride ourselves on our independence and drive to challenge
                  the rigid system of airlines and carriers in the best
                  interests of our customers. As tech innovators, we’re creating
                  solutions to make affordable travel available to everyone. As
                  people, we’re changing the way we travel to make a more open
                  and tolerant society.
                </Typography>
              </CardContent>
            </Box>
            <CardMedia
              component="img"
              className="col-sm-12 col-md-5 col-lg-4 about-card-media"
              image="/img/_3.png"
              alt="Live from space album cover"
            />
          </Card>
        </div>
      </Grid>
      <Footer />
    </>
  );
};

export default React.memo(AboutUs);
